module.exports = __webpack_public_path__ + "img/shuzhongjiankong.9aab0307.png";